/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Component
import { PriceLabel } from './PriceLabel';

type RetailProps = {|
    currency: string,
    showLabel: boolean,
    price: number,
    quantityDisplay?: string,
    showPriceVariability: boolean,
|};

export function Retail({
    currency,
    price,
    showLabel,
    quantityDisplay,
    showPriceVariability,
}: RetailProps) {
    const label = (
        <FormattedMessage id="dc.searchProductTile.listPrice" defaultMessage="List Price" />
    );

    return (
        <PriceLabel
            price={price}
            label={showLabel ? label : ''}
            quantityDisplay={quantityDisplay}
            currency={currency}
            showPriceVariability={showPriceVariability}
        />
    );
}

Retail.defaultProps = {
    showLabel: false,
    showPriceVariability: false,
};
